<template>
  <div class="login-page">
    <div class="row">

      <div class="col-md-4 col-sm-6 col-lg-3 center-block">
        <div class="card">
          <div class="card-block">
            <div class="text-center mt-3">
              <img src="../assets/img/logo.png" height="52" alt="logo">
            </div>

            <h4 class="text-muted text-center font-18 mt-3"><b>Ingresar</b></h4>

            <div class="p-3">
              <div class="alert alert-danger p-3" role="alert" v-if="error">{{ error }}</div>
              <div class="alert alert-success p-3" role="alert" v-if="loggingIn">Ingresando...</div>

              <div class="form-group" v-bind:class="{ 'has-danger': $v.credentials.email.$error }">
                <input
                  type="email"
                  class="form-control"
                  placeholder="Email"
                  v-model="credentials.email"
                  @keyup.enter="submit()"
                  @input="$v.credentials.email.$touch()">
                <div class="form-control-feedback" v-if="!$v.credentials.email.required && $v.credentials.email.$error">El email es requerido.</div>
                <div class="form-control-feedback" v-if="!$v.credentials.email.email && $v.credentials.email.$error">Ingrese un email válido.</div>
              </div>
              <div class="form-group" v-bind:class="{ 'has-danger': $v.credentials.password.$error }">
                <input
                  type="password"
                  class="form-control"
                  placeholder="Contraseña"
                  v-model="credentials.password"
                  @keyup.enter="submit()"
                  @input="$v.credentials.password.$touch()">
                <div class="form-control-feedback" v-if="!$v.credentials.password.required && $v.credentials.password.$error">La contraseña es requerida.</div>
              </div>
              <div class="form-group text-center row m-t-20">
                <div class="col-12">
                  <button class="btn btn-primary btn-block waves-effect waves-light login-btn" @click="submit()">Ingresar</button>
                </div>
              </div>
            </div>

            <div class="text-center mt-3">
              <p class="text-muted">¿Todavía no estas registrado?</p>
              <router-link to="/signup" class="text-primary">Registrate</router-link>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import { required, email } from 'vuelidate/lib/validators'

  export default {
    name: 'login',
    data () {
      return {
        credentials: {
          email: '',
          password: ''
        },
        loggingIn: false,
        error: ''
      }
    },
    validations: {
      credentials: {
        email: {
          required,
          email
        },
        password: {
          required
        }
      }
    },
    methods: {
      submit () {
        this.error = null
        this.$v.credentials.$touch()

        if(!this.$v.credentials.$error) {

          $('.login-btn').attr('disabled', true);

          var credentials = {
            email: this.credentials.email,
            password: this.credentials.password
          }

          this.loggingIn = true

          this.$auth.login(credentials, {path: '/'}).then((response) => {
            this.loggingIn = false

            if (!response.body.success) {
              this.error = response.body.message
            }

            $('.login-btn').attr('disabled', false);
          })

        }
      }
    }

  }
</script>

<style scoped>
  .login-page{
    margin-top: 9.5%;
  }
  .center-block {
    float: none;
    margin-left: auto;
    margin-right: auto;
  }
</style>



// WEBPACK FOOTER //
// src/screens/LoginScreen.vue